import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router'

import Button from '../../Button'
import { AuthFooter } from '../AuthFooter'
import { AuthHeader } from '../AuthHeader'
import { AuthHelpText } from '../AuthHelpText'
import { AuthPanel } from '../AuthPanel'
import { AuthTitle } from '../AuthTitle'

import * as styles from './AuthInvalidHash.module.css'

function AuthInvalidHash({
  restartLink,
  text,
  title = 'Auth.InvalidHashTitleKey',
}) {
  const { t } = useTranslation()

  const navigate = useNavigate()

  function handleClickRestartButton() {
    navigate(restartLink, { replace: true })
  }

  return (
    <AuthPanel>
      <AuthHeader />
      <AuthTitle className={styles.title} title={t(title)} />
      <AuthHelpText className={styles.helpText} text={t(text)} />
      {restartLink ? (
        <Button.Contained
          text={t('Auth.InvalidHasRestartButtonKey')}
          onClick={handleClickRestartButton}
        />
      ) : null}
      <AuthFooter />
    </AuthPanel>
  )
}

export default AuthInvalidHash
